<template>
  <div class="steps-card card">
    <a-steps
      :current="current"
      :direction="isMobile ? 'horizontal' : 'vertical'"
      :size="isMobile ? 'default' : 'small'"
      class="payment-steps"
    >
      <a-step
        v-for="(step) in steps"
        :key="step.id"
        :status="renderStatus(step)"
        :title="step.title"
        :description="step.description"
      >
        <a-icon
          slot="icon"
          :type="renderIcon(step)"
        />
      </a-step>
    </a-steps>
  </div>
</template>

<script>
export default {
  name: 'PaymentSteps',
  props: {
    current: {
      type: Number,
      required: true,
    },
    steps: {
      type: Array,
      required: true,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    renderStatus(step) {
      if (this.current === step.number) {
        return 'process';
      }

      if (this.current >= step.number) {
        return 'finish';
      }

      return step.status;
    },

    renderIcon(step) {
      if (this.current === step.number) {
        return 'loading';
      }

      return step.icon;
    },
  },
};
</script>

<style scoped>
.steps-card {
  padding: var(--spacing-md);
  margin-bottom: var(--spacing-md);
}

.payment-steps {
  margin-bottom: var(--spacing-md);
}
</style>
